<div class="sidenav-menu main-page-render">
  <app-logo-box />

  <button class="button-sm-hover">
    <i class="ti ti-circle align-middle"></i>
  </button>

  <button class="button-close-fullsidebar" (click)="closeSidebar()">
    <i class="ti ti-x align-middle"></i>
  </button>
  <ngx-simplebar data-simplebar>
    <ul class="side-nav">
      @for (item of menuItems; track item.label; let first = $first) {
        @if (item.isTitle) {
          <li class="side-nav-title">{{ item.label }}</li>
        } @else {
          @if (hasSubmenu(item)) {
            <ng-container
              *ngTemplateOutlet="
                MenuItemWithChildren;
                context: {
                  menu: item,
                  linkClassName: 'side-nav-link nav-link-ref',
                  subMenuClassNames: 'sub-menu',
                  itemClassName: 'side-nav-item',
                }
              "
            >
            </ng-container>
          } @else {
            <ng-container
              *ngTemplateOutlet="
                MenuItem;
                context: {
                  menu: item,
                  linkClassName: 'side-nav-link nav-link-ref',
                  itemClassName: 'side-nav-item',
                }
              "
            >
            </ng-container>
          }
        }
      }
    </ul>

    <div class="clearfix"></div>
  </ngx-simplebar>
</div>
<!-- children working -->
<ng-template
  #MenuItemWithChildren
  let-menu="menu"
  let-itemClassName="itemClassName"
  let-linkClassName="linkClassName"
  let-subMenuClassNames="subMenuClassNames"
>
  <li [class]="itemClassName">
    <a
      [class]="linkClassName"
      [ngClass]="{ active: activeMenuItems.includes(menu.key) }"
      (click)="toggleMenuItem(menu, collapse); onMenuItemClick(menu)"
      role="button"
      [attr.aria-expanded]="!menu.collapsed"
      aria-controls="sidebarDashboards"
      [attr.aria-controls]="menu.key"
    >
      @if (menu.icon) {
        <span class="menu-icon">
          <i class="ti {{ menu.icon }}"></i>
        </span>
      }
      <span
        class="menu-text"
        [ngClass]="{ 'long-title': menu.label?.length > 24 }"
      >
        {{ menu.label }}
      </span>
      <span class="menu-arrow"></span>
    </a>
    <div
      #collapse="ngbCollapse"
      [(ngbCollapse)]="menu.collapsed"
      class="collapse"
      id="sidebarDashboards"
    >
      <ul [class]="subMenuClassNames">
        @if (menu.showSearchDropDown) {
          <app-sidebar-search
            class="side-nav-item"
            (practiceSelected)="onPracticeSelected($event)"
          />
        }
        @for (child of menu.children; track child.label) {
          @if (hasSubmenu(child)) {
            <ng-container
              *ngTemplateOutlet="
                MenuItemWithChildren;
                context: {
                  menu: child,
                  linkClassName: 'side-nav-link nav-link-ref',
                  itemClassName: 'side-nav-item',
                  subMenuClassNames: 'sub-menu',
                }
              "
            >
            </ng-container>
          } @else {
            @if (menu.showChildren) {
              <ng-container
                *ngTemplateOutlet="
                  MenuItem;
                  context: {
                    menu: child,
                    linkClassName: 'side-nav-link nav-link-ref',
                    itemClassName: 'side-nav-item',
                  }
                "
              >
              </ng-container>
            }
          }
        }
      </ul>
    </div>
  </li>
</ng-template>

<ng-template
  #MenuItem
  let-menu="menu"
  let-linkClassName="linkClassName"
  let-itemClassName="itemClassName"
>
  <li
    [class]="itemClassName"
    [ngClass]="{ active: activeMenuItems.includes(menu.key) }"
  >
    <ng-container
      *ngTemplateOutlet="
        MenuItemLink;
        context: { menu: menu, className: linkClassName }
      "
    >
    </ng-container>
  </li>
</ng-template>

<ng-template #MenuItemLink let-menu="menu" let-className="className">
  <!-- @if(menu.showSearchDropDown){
      <app-sidebar-search 
      />
    } -->
  <a
    [routerLink]="menu.url"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    [class]="className"
    [ngClass]="{
      active: activeMenuItems.includes(menu.key),
      disabled: menu.isDisabled,
    }"
    [attr.aria-controls]="menu.key"
    (click)="onMenuItemClick(menu)"
  >
     @if (menu.icon) {
      <span class="menu-icon">
        <i class="ti {{ menu.icon }}"></i>
      </span>
      <span
        class="menu-text"
        >
        <!-- [ngClass]="{ 'long-title': menu.label?.length > 24 }" -->
        {{ menu.label }}
      </span>
    } @else {
      {{ menu.label }}
    }
    @if (menu.badge) {
      <span class="badge rounded-pill text-end bg-{{ menu.badge.variant }}">{{
        menu.badge.text
      }}</span>
    }
  </a>
</ng-template>
